import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';

@Injectable({
  providedIn: 'root'
})

export class InvoiceService {

  private url = environment.do_services_sb_url;
  private getInvDetailsUrl = 'invoice/getInvoiceDetails';

  constructor(private http: HttpClient, private authService: AuthService,
              private popupService: PopupService, private route: Router) { }

  getInvoiceDetails(user_mail: string): Observable<any> {
    return this.http.post(this.url + this.getInvDetailsUrl, user_mail, { responseType: 'text' }).pipe(
      map((response: any) => {
        const run = response;
        return run;
      }),
      catchError((error: any) => {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
          return throwError(() => error);
        }
        if(error.status === 401) {
          const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
            data: { message: 'Unauthorized Request - Your Session has expired' }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.authService.logout().subscribe(() => {
              this.route.navigate(['/home']);
            });
          });
          return throwError(() => new Error('Unauthorized Request - Session expired'));
        }
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
      })
    );
  }

}